import React, { useEffect, useState } from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, CircularProgress, Typography } from '@mui/material';
import { fetchWithToken } from "../api/apiutils"; 

const UserLotsTable = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchWithToken('/api/lots/count');
        if (!response.ok) {
          throw new Error('Не удалось получить данные');
        }
        const responseData = await response.json();
        setData(responseData);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Typography color="error">Ошибка: {error}</Typography>;
  }

  if (!data) {
    return <Typography>Нет данных</Typography>;
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Госзакуп</TableCell>
            <TableCell>Postgre</TableCell>
            <TableCell>Mongo</TableCell>
            <TableCell>graphQL</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{data.inGosZakup}</TableCell>
            <TableCell>{data.inPostgresql}</TableCell>
            <TableCell>{data.inMongoDb}</TableCell>
            <TableCell>{data.ingraphQL}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UserLotsTable;